import { render, staticRenderFns } from "./public-quiz-question-answer-create.html?vue&type=template&id=363385d8&scoped=true&"
import script from "./public-quiz-question-answer-create.js?vue&type=script&lang=js&"
export * from "./public-quiz-question-answer-create.js?vue&type=script&lang=js&"
import style0 from "./public-quiz-question-answer-create.scss?vue&type=style&index=0&id=363385d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363385d8",
  null
  
)

export default component.exports